import { render, staticRenderFns } from "./supplierprofile.vue?vue&type=template&id=1a0d7bd2&"
import script from "./supplierprofile.vue?vue&type=script&lang=js&"
export * from "./supplierprofile.vue?vue&type=script&lang=js&"
import style0 from "./supplierprofile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports